// 基于 IntersectionObserver 的可视区检测指令
// 用法：
// <div v-inview="(visible) => { /* do something */ }"></div>
// 可选：arg 为一次性触发：v-inview:once

const inview = {
  mounted(el, binding) {
    const isOnce = binding.arg === 'once';
    const callback = typeof binding.value === 'function' ? binding.value : () => {};

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const visible = entry.isIntersecting || entry.intersectionRatio > 0;
        callback(visible);
        if (visible && isOnce) {
          observer.unobserve(el);
          observer.disconnect();
          el._inviewObserver = null;
        }
      });
    }, options);

    observer.observe(el);
    el._inviewObserver = observer;
  },
  unmounted(el) {
    if (el._inviewObserver) {
      try {
        el._inviewObserver.unobserve(el);
        el._inviewObserver.disconnect();
      } catch (e) {
        console.error(e);
      }
      el._inviewObserver = null;
    }
  }
};

export default inview;
